<div class="slider-container">
  <mat-slider
    id="time-slider"
    [step]="1"
    [min]="1"
    [max]="calculatedStep"
    [displayWith]="sliderDisplayWith"
    thumbLabel
    #ngSlider
    ><input
      [(ngModel)]="sliderValue"
      matSliderThumb
      (input)="
        handleSliderInput({
          source: ngSliderThumb,
          parent: ngSlider,
          value: ngSliderThumb.value
        })
      "
      #ngSliderThumb="matSliderThumb"
    />
  </mat-slider>
  <button mat-icon-button color="primary" (click)="playFilter()">
    <mat-icon>{{ playIcon }}</mat-icon>
  </button>
  <button mat-icon-button color="primary" (click)="resetFilter()">
    <mat-icon>{{ resetIcon }}</mat-icon>
  </button>
</div>
